<template>
  <Page class="mine-online" :loading="loading" :empty="empty" :icon="noContract" desc="当前无合同">
    <Navbar title="在线签约" :customClickLeft="returnedFromDriverCa" @clickLeft="handleClickLeft"> </Navbar>
    <div class="pa-16 bg-white" v-if="contractList && contractList.length > 0">
      <div class="font-16 mb-24">
        点击“确认签署”即代表您已同意以下合同内容：
      </div>
      <CheckboxGroup v-model="checkList">
        <div
          @click="() => handleJump(item)"
          class="sign-card bda-4 mb-16 d-flex pa-16 bda justify-space-between"
          v-for="(item, index) in contractList"
          :key="index"
        >
          <div class="font-16 fw-500 d-flex">
            <div class="pt-4">
              <Checkbox class="mr-8 font-16" :name="index" shape="square" />
            </div>
            <div>
              <div>{{ item.contractName }}</div>
              <div class="font-12 text_secondary">
                {{ item.taxSourceCompanyName }}
              </div>
            </div>
          </div>
          <div class="lh-40">
            <Icon name="jt-h" />
          </div>
        </div>
      </CheckboxGroup>
    </div>
    <div slot="toolbar" class="btn-box" @click="handleSigned">
      <Button size="large" type="primary">确认签署</Button>
    </div>
  </Page>
</template>
<script>
import { defineComponent, ref, onMounted } from '@vue/composition-api';
import { Checkbox, CheckboxGroup } from 'vant';
import { apiUnsignList, apiSignConstruct } from '@api/mine';
import { Button, Toast } from 'vant';
import { useRouterQuery } from '@hook/useRouterQuery';
import { useRouter } from '@/utils/compsitionHack';
import { useUserStore } from '@/store/user';
import { PageEnum } from '@/enums/pageEnum';
import { confirmDriverCaAuthRedirect, shouldSkipDriverCaAutoCheck } from '@/utils/driverCaAuth';

export default defineComponent({
  name: 'Online',
  components: {
    Button,
    CheckboxGroup,
    Checkbox
  },
  props: {
    dataDetail: {
      type: Object,
      default: () => {}
    }
  },
  setup(_, ctx) {
    const contractList = ref([]);
    const checkList = ref([]);
    const router = useRouter();
    const query = useRouterQuery();
    const noContract = require('@/assets/htkb.png');
    const userStore = useUserStore();
    const loading = ref(true);
    const empty = ref(false);
    const returnedFromDriverCa = ref(false);
    const handleClickLeft = () => {
      if (query.routerBack === '1') {
        ctx.root.$routerBack.call(ctx.root._router);
      } else {
        router.replace(PageEnum.CONTRACT_LIST);
      }
    };
    const handleSigned = async () => {
      try {
        const res = await apiSignConstruct({
          driverId: userStore.driverId,
          redirectTo: window.location.href
        });
        if (await confirmDriverCaAuthRedirect(res.data)) return;
        if (res) {
          Toast.success('签约成功！');
          if (query.routerBack === '1') {
            ctx.root.$routerBack.call(ctx.root._router);
          } else {
            router.replace(PageEnum.CONTRACT_LIST);
          }
        }
      } catch (err) {
        Toast.fail(err);
      }
    };
    const handleJump = async item => {
      router.push({
        path: PageEnum.AGREEMENT,
        query: {
          taxSourceId: item.taxSourceId,
          tosbSecretConfigId: item.tosbSecretConfigId || ''
        }
      });
    };
    onMounted(async () => {
      loading.value = false;
      try {
        await userStore.getUserInfoAction();
        returnedFromDriverCa.value = shouldSkipDriverCaAutoCheck();
        const unsignList = await apiUnsignList({
          driverId: userStore.driverId
        });
        if (unsignList.data.length) {
          contractList.value = unsignList.data;
          checkList.value = contractList.value.map((item, index) => index);
        } else {
          Toast.success('当前无未签约合同!');
          empty.value = true;
        }
      } catch (err) {
        Toast.fail(err);
      }
    });
    return {
      checkList,
      contractList,
      noContract,
      handleSigned,
      handleJump,
      handleClickLeft,
      loading,
      empty,
      returnedFromDriverCa
    };
  }
});
</script>
<style lang="less">
.mine-online {
  min-height: 100%;
  .van-checkbox {
    .van-checkbox__icon {
      font-size: 0.16rem;
    }
  }

  .page__content {
    background-color: white;
    bottom: 0.98rem !important;
  }
}
</style>
